import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["debtors.createDebtorDialog"],
  payload => payload
);
